
document.addEventListener("DOMContentLoaded", function () {
    const youtubePlayers = {};
    const vimeoPlayers = {};
  
    // Asegurarse de que la API de YouTube esté lista antes de inicializar
    window.onYouTubeIframeAPIReady = function () {
      initVideoSlider();
    };
  
    function initVideoSlider() {
      // Inicializa los reproductores de YouTube (excluye clones)
      const initYTPlayers = () => {
        document
          .querySelectorAll('.card-slider-video:not(.slick-cloned) iframe[src*="youtube"]')
          .forEach(iframe => {
            if (iframe.id && !youtubePlayers[iframe.id]) {
              youtubePlayers[iframe.id] = new YT.Player(iframe.id, {
                events: {
                  'onStateChange': e => {
                    if (e.data === YT.PlayerState.PLAYING) {
                      pauseOthers(e.target.getIframe());
                    }
                  }
                }
              });
            }
          });
      };
  
      // Inicializa los reproductores de Vimeo (excluye clones)
      const initVimeoPlayers = () => {
        document
          .querySelectorAll('.card-slider-video:not(.slick-cloned) iframe[src*="vimeo"]')
          .forEach(iframe => {
            if (iframe.id && !vimeoPlayers[iframe.id]) {
              vimeoPlayers[iframe.id] = new Vimeo.Player(iframe);
              // vimeoPlayers[iframe.id].on('play', e => pauseOthers(e.target));
            }
          });
      };
  
      // Función que pausa todos los videos/iframes excepto el activo
      const pauseOthers = activeEl => {
        document
          .querySelectorAll('.card-slider-video video, .card-slider-video iframe')
          .forEach(el => {
            if (el.closest('.slick-cloned') || el === activeEl) return;
            if (el.tagName === 'VIDEO') {
              el.pause();
            } else if (el.tagName === 'IFRAME') {
              if (youtubePlayers[el.id]) {
                youtubePlayers[el.id].pauseVideo();
              } else if (vimeoPlayers[el.id]) {
                vimeoPlayers[el.id].pause();
              } else {
                el.contentWindow.postMessage(
                  '{"event":"command", "func":"pauseVideo", "args":""}',
                  '*'
                );
              }
            }
          });
      };
  
      // Inicializa Slick (slider)
      $(".content-slider-video").slick({
        dots: false,
        infinite: true,
        speed: 300,
        slidesToShow: 2,
        slidesToScroll: 2,
        prevArrow:
          "<a href='#' class='previous-arrow' aria-label='Previous Slide'>" +
          "<svg xmlns='http://www.w3.org/2000/svg' height='16' width='10' viewBox='0 0 320 512'>" +
          "<path d='M41.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3" +
          "L109.3 256 246.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z'/></svg></a>",
        nextArrow:
          "<a href='#' class='next-arrow' aria-label='Next Slide'>" +
          "<svg xmlns='http://www.w3.org/2000/svg' height='16' width='10' viewBox='0 0 320 512'>" +
          "<path d='M278.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-160 160c-12.5 12.5-32.8 12.5-45.3 0s12.5-32.8 0-45.3" +
          "L210.7 256 73.4 118.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l160 160z'/></svg></a>",
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      });
  
      // Inicializa los reproductores después de que Slick esté listo
      initYTPlayers();
      initVimeoPlayers();
    }
  
    // Verifica si la API de YouTube ya está lista, en caso contrario la espera
    if (window.YT && window.YT.Player) {
      onYouTubeIframeAPIReady();
    }
  
    var maxLength = 40; // length limit
    document.querySelectorAll('.content-description').forEach(function(p) {
      var fullText = p.textContent;
      if (fullText.length > maxLength) {
        var shortText = fullText.substring(0, maxLength) + '... ';
        var moreLink = document.createElement('a');
        moreLink.href = '#';
        moreLink.textContent = 'Read more';
        moreLink.style.cursor = 'pointer';
  
        var lessLink = document.createElement('a');
        lessLink.href = '#';
        lessLink.textContent = 'Show less';
        lessLink.style.cursor = 'pointer';
  
        // show text init
        p.innerHTML = shortText;
        p.appendChild(moreLink);
  
        moreLink.addEventListener('click', function(e) {
          e.preventDefault();
          p.innerHTML = fullText + ' ';
          p.appendChild(lessLink);
        });
  
        lessLink.addEventListener('click', function(e) {
          e.preventDefault();
          p.innerHTML = shortText;
          p.appendChild(moreLink);
        });
      }
    });
  });
  
  